export default function Footer() {
  return (
    <footer className="bg-brand-dark text-gray-300">
      <div className="section-container py-12 md:py-16">
        <div className="max-w-4xl">
          {/* Singapore */}
          <div>
            <h4 className="text-xs font-bold tracking-widest uppercase text-brand-gold mb-6">
              SINGAPORE
            </h4>
            <div className="space-y-1 text-sm leading-relaxed text-gray-400">
              <p>6 Eu Tong Sen Street</p>
              <p>#12-12 The Central</p>
              <p>Singapore 059817</p>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright Bar */}
      <div className="border-t border-white/10">
        <div className="section-container py-5">
          <p className="text-center text-xs text-gray-500">
            Copyright &copy; {new Date().getFullYear()} Property Growth. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}